import { useAuthContext } from '@/context/AuthContext';
import {useQuery} from '@apollo/client/react';
import { gql } from '@apollo/client';
import { useParams } from 'react-router-dom';

const CONSULTANT_INVOICES_QUERY = gql`
    query ConsultantInvoices($invoiceRequest: ConsultantInvoiceRequestDto!) {
        consultantInvoices(invoiceRequest: $invoiceRequest) {
            invoices {
                year
                uuid
                periodStart
                periodEnd
                month
                invoiceNumber
                invoiceDate
                daysWorked
                paymentDate
                dailyRateConsultant
                dailyRateClient
                currency
                clientName
                amountConsultant
                amountClient
                commission
                manualCommission
                boondManagerInvoiceId
            }
            year
        }
    }
`;

const useConsultantInvoices = (year = null) => {
    const { id: consultantUuid } = useParams();
    // const shouldSkipQuery = !consultantUuid || year == null;

    const { data, loading, error,refetch } = useQuery(CONSULTANT_INVOICES_QUERY, {
        variables: {
            invoiceRequest: {
                consultantUuid,
                year,
            },
        },
        // skip: shouldSkipQuery,
        fetchPolicy: "network-only",
    });

    return {
        invoices: data?.consultantInvoices?.invoices || [],
        year: data?.consultantInvoices?.year || null,
        loading,
        error,
        refetch: refetch || (() => Promise.resolve())
    };
};

export default useConsultantInvoices;
